module.exports = __webpack_public_path__ + "img/Birria-Burrito.706371ce.jpg";